'use client';
import { jsxs, jsx, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { Root as Root2, Trigger, Portal as Portal2, Content as Content2 } from './../../../external/@radix-ui/react-dropdown-menu/dist/index.js';
import { Fragment, useMemo, useState, useEffect, useCallback } from 'react';
import { IconChevronLeft } from '../../svg/icons/icon-chevron-left.js';
import { MenuItemSeparator, MenuItem } from './menu-item.js';

const Menu = ({ itemSections, asChild = false, align = 'start', sideOffset = 4, children, onOpenChange, fillParentWidth = false, subMenusInPageView = false, loading = false, }) => {
    const sections = itemSections.filter((section) => section.length > 0);
    /**
     * Changes properties on the parent content element to fill the parent width
     * @param el
     * @returns
     */
    const refCallback = (el) => {
        const parent = el?.parentElement;
        if (!parent || !fillParentWidth) {
            return;
        }
        parent.style.right = '0';
        parent.style.position = 'absolute';
        parent.style.zIndex = '5';
    };
    // Filling parent means to put it inline with the parent (no portal)
    const Container = fillParentWidth ? Fragment : Portal2;
    return (jsxs(Root2, { onOpenChange: onOpenChange, modal: !fillParentWidth, children: [jsx(Trigger, { className: "focus:outline-none", asChild: asChild, children: children }), jsx(Container, { children: jsx(Content2, { className: "min-w-48 rounded-md border border-leland-gray-stroke bg-leland-white p-2 shadow-md", collisionPadding: { top: 80, bottom: 80, left: 20, right: 20 }, avoidCollisions: true, align: align, sideOffset: sideOffset, sticky: "partial", ref: refCallback, children: loading ? (jsxs("div", { className: "flex flex-col gap-2", children: [jsx("div", { className: "h-10 w-full animate-pulse rounded-md bg-leland-gray-hover" }), jsx("div", { className: "h-10 w-full animate-pulse rounded-md bg-leland-gray-hover" }), jsx("div", { className: "h-10 w-full animate-pulse rounded-md bg-leland-gray-hover" })] })) : (jsx("div", { className: "max-h-[--radix-dropdown-menu-content-available-height] overflow-y-auto", children: jsx(Content, { itemSections: sections, subMenusInPageView: subMenusInPageView }) })) }) })] }));
};
const Content = ({ itemSections, subMenusInPageView, }) => {
    const hasLeftIcons = itemSections.some((section) => section.some((item) => item.LeftIcon || item.CustomLeftIcon));
    const { sections: pageSections, onSelect: onSelectPage } = usePageSubmenus(itemSections);
    const sections = subMenusInPageView ? pageSections : itemSections;
    return (jsx(Fragment$1, { children: sections.map((section, sectionIndex) => (jsxs(Fragment, { children: [sectionIndex > 0 ? (jsx(MenuItemSeparator, {}, `separator-${sectionIndex}`)) : null, section.map((item, itemIndex) => (jsx(MenuItem, { includeLeftIconPlaceholder: hasLeftIcons, ...item, pageView: subMenusInPageView, ...(subMenusInPageView
                        ? { onSelect: (e) => onSelectPage(e, item) }
                        : {}) }, `item-${sectionIndex}-${itemIndex}`)))] }, `section-${sectionIndex}`))) }));
};
const usePageSubmenus = (sections) => {
    const items = useMemo(() => {
        const addPageToSections = (sections, parent) => {
            const node = {
                sections,
                nodeSections: [],
                parent,
            };
            const sectionNodes = sections.map((section) => section.map((item) => {
                const itemNode = {
                    ...item,
                    nodeItems: undefined,
                };
                if (item.items) {
                    const subsections = addPageToSections(item.items, node);
                    itemNode.nodeItems = subsections;
                }
                return itemNode;
            }));
            node.nodeSections = sectionNodes;
            return node;
        };
        return addPageToSections(sections);
    }, [sections]);
    const [currentNode, setCurrentNode] = useState(items);
    // Update the state if sections prop changes
    useEffect(() => {
        setCurrentNode(items);
    }, [items]);
    const handleSelect = useCallback((e, item) => {
        if (item.nodeItems) {
            // Prevent the menu from closing
            e.stopPropagation();
            e.preventDefault();
            setCurrentNode(item.nodeItems);
        }
        else {
            item.onSelect?.(e);
        }
    }, []);
    const pageSections = useMemo(() => [
        ...(currentNode.parent !== undefined
            ? [
                [
                    {
                        label: 'Back',
                        LeftIcon: IconChevronLeft,
                        items: currentNode.parent.sections,
                        nodeItems: currentNode.parent,
                    },
                ],
            ]
            : []),
        ...currentNode.nodeSections,
    ], [currentNode]);
    return {
        sections: pageSections,
        onSelect: handleSelect,
    };
};

export { Menu };
//# sourceMappingURL=menu.js.map
